import { Box, ModalHeader } from '@wrisk/ui-components'
import React, { FunctionComponent, useState } from 'react'

import { useApiErrorHandlingAsyncCallback } from '../../../hooks/auth'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { FeedbackConfig } from '../../../state/configuration'
import { usePrincipal } from '../../authentication'
import { useProposal } from '../../product/proposal/proposalContext'
import { FeedbackForm } from './FeedbackForm'
import { FeedbackModalConfirmation } from './FeedbackModalConfirmation'

const tKey = TKey('components.feedback-modal')

export interface FeedbackFormData {
  [key: string]: string

  rating: string
  comment: string
}

interface FeedbackModalProps {
  config: FeedbackConfig
  tags: Record<string, string>
}

export const FeedbackModal: FunctionComponent<FeedbackModalProps> = ({
  config,
  tags,
}) => {
  const { t } = useWriskTranslation()
  const { apiClient } = usePrincipal()
  const { proposal } = useProposal()

  const [showConfirmationView, setShowConfirmationView] = useState(false)

  const onSubmit = useApiErrorHandlingAsyncCallback(async (data: FeedbackFormData) => {
    if (!proposal.policyId) return

    const action = config.actions[data.rating]

    if (action === 'confirmation') {
      await apiClient.postInsight({
        type: config.type,
        values: data,
        tags,
      })
      setShowConfirmationView(true)
    }
  })

  return showConfirmationView ? (
    <FeedbackModalConfirmation />
  ) : (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <FeedbackForm type={config.type} onSubmit={onSubmit} />
    </Box>
  )
}
